import Dialog from "../common/Dialog";
import { Button } from "../ui/button";
import { toast } from "react-toastify";
import { useState } from "react";
import TrashCanSvg from "../../assets/svg/TrashCan.svg";
import DownloadSvg from "../../assets/svg/DownLoad.svg";
import { Task } from "@/api/mutation/useTaskCreateMutation";
import useRemoveTaskAttachmentMutation from "@/api/mutation/useTaskAttechmentRemoveMutation";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useAttachmentUpdateMutation from "@/api/mutation/useAttachmentUpdateMutation";
import { useFormik } from "formik";
import { taskAttachmentSchema } from "@backend/src/schemas/taskSchema";
import { toFormikValidationSchema } from "zod-formik-adapter";
import GreenChackMark from "@/assets/svg/GreenChackMark.svg";
import editNew from "@/assets/svg/editNew.svg";
import crossNew from "@/assets/svg/CrossIcon.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
type Props = {
  task: Task | undefined;
  refetch: () => void;
  allowed?: boolean;
};

function TaskAttachment(props: Props) {
  const removeTaskAttachmentMutation = useRemoveTaskAttachmentMutation();
  const [showAllAttachment, setShowAllAttachment] = useState<boolean>(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null
  );
  const { t } = useTranslation();
  const removeConfirm = () => {
    if (showConfirmDelete) {
      removeTaskAttachmentMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          props.refetch();
          toast.success(data.data.message);
          setShowConfirmDelete(null);
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
          setShowConfirmDelete(null);
        },
      });
    }
  };
  const formik = useFormik({
    initialValues: {
      label: "",
    },
    validationSchema: toFormikValidationSchema(taskAttachmentSchema),
    onSubmit(values) {
      attachmentUpdateMutation.mutate(values, {
        onSuccess(data) {
          props.refetch();
          setLabel("");
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    },
  });
  const [label, setLabel] = useState<string>("");
  const attachmentUpdateMutation = useAttachmentUpdateMutation(label);

  return (
    <div className="max-h-52 overflow-auto px-2 mt-3">
      {props.task?.documentAttachments
        .slice(
          0,
          showAllAttachment ? props.task?.documentAttachments.length : 5
        )
        .map((item) => {
          return (
            <div className="text-xs w-full flex gap-10 items-center justify-between my-3">
              <div className="flex items-center gap-1 text-nowrap truncate">
                <a
                  href={item.url}
                  target="_blank"
                  className="opacity-90 flex gap-1 items-center"
                >
                  <img src={DownloadSvg} className="min-w-3.5 w-3.5" />
                </a>
                {item.name}
              </div>
              <div
                className={`text-gray-400 flex items-center justify-end gap-2 ${
                  label ? " w-[50%]" : "w-[30%]"
                }`}
              >
                {label === item.attachmentId ? (
                  <div className="flex gap-2 items-center">
                    <input
                      type="text"
                      name="label"
                      value={formik.values.label}
                      onChange={(e) =>
                        formik.setFieldValue("label", e.target.value)
                      }
                      className="border border-gray-300 rounded-md px-2 py-1 text-xs"
                      onKeyUp={(e) => {
                        if (e.key == "Enter") {
                          formik.submitForm();
                        }
                      }}
                    />
                    <div className="flex gap-1">
                      <Button
                        className="p-0 mx-2"
                        variant={"none"}
                        onClick={formik.submitForm}
                      >
                        <img src={GreenChackMark} className="w-4 min-w-4" />
                      </Button>
                      <Button
                        className="p-0 mx-2"
                        variant={"none"}
                        onClick={() => {
                          setLabel("");
                          formik.setFieldValue("label", "");
                        }}
                      >
                        <img
                          src={crossNew}
                          className="w-2.5 min-w-2.5 brightness-0"
                        />
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="w-fit">
                    {item.label ? (
                      <div className="flex gap-2 items-center">
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <div className="overflow-hidden whitespace-nowrap text-ellipsis truncate max-w-[100px]">
                                {item.label}
                              </div>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm"> {item.label}</p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                        <img
                          src={editNew}
                          className="w-3 min-w-3 cursor-pointer"
                          onClick={() => {
                            setLabel(item.attachmentId);
                            formik.setFieldValue("label", item.label);
                          }}
                        />
                      </div>
                    ) : (
                      props.allowed ? <p
                        className="whitespace-nowrap text-primary-500 underline cursor-pointer"
                        onClick={() => setLabel(item.attachmentId)}
                      >
                        {t("add label")}
                      </p> :""
                    )}
                  </div>
                )}

                { props.allowed &&<div className="">
                  <Button
                    variant={"none"}
                    className="p-0 !h-0"
                    onClick={() => setShowConfirmDelete(item.attachmentId)}
                  >
                    <img src={TrashCanSvg} className="w-3 min-w-3" />
                  </Button>
                </div>}
              </div>
            </div>
          );
        })}
      {props.task?.documentAttachments &&
        props.task?.documentAttachments.length > 2 && (
          <div
            className="text-end text-xs cursor-pointer text-primary-500"
            onClick={() => setShowAllAttachment((prev) => !prev)}
          >
            {!showAllAttachment ? t("view_more") : ""}
          </div>
        )}
      <Dialog
        isOpen={showConfirmDelete ? true : false}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCanSvg} className="w-12 m-auto" />
          {t("common_delete_message_file")} 
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeTaskAttachmentMutation.isPending}
              disabled={removeTaskAttachmentMutation.isPending}
              onClick={() => setShowConfirmDelete(null)}
            >
              {t("cancel")}
            </Button>
            <Button variant={"primary"} onClick={removeConfirm}>
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default TaskAttachment;
